import { Search } from './models/search';

export class GetSearchHistory {
  static readonly type = '[Searches] - Get search history';
}

export class GetSavedSearches {
  static readonly type = '[Searches] - Get saved Searches';
}

export class PostSearch {
  static readonly type = '[Searches] - Post search';

  constructor(public search: Search) {}
}

export class DeleteSearch {
  static readonly type = '[Searches] - Delete search';

  constructor(public searchId: number) {}
}

export class PostSavedSearchToHistory {
  static readonly type = '[Searches] - Post saved search to history';

  constructor(public search: Search) {}
}